"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.strength = strength;
exports.base64url_encode = base64url_encode;
exports.isAscii = isAscii;
/* eslint-disable no-control-regex */
const commonPasswords_1 = __importDefault(require("./commonPasswords"));
const entropy_1 = __importDefault(require("./entropy"));
/*
 * Check the strength of a password.
 *
 * @returns
 *   entropy: The entropy of the string.
 *   strength: A strength value (0,1,2,3).
 *   ok: Is this is an acceptable password.
 *   common: Is this is a common password.
 */
function strength(input) {
    const _entropy = (0, entropy_1.default)(input);
    const commonPass = (0, commonPasswords_1.default)(input);
    const ok = _entropy &&
        input &&
        input.length >= 8 &&
        _entropy.frequency > 4 &&
        !commonPass;
    const e = _entropy && _entropy.entropy;
    let s = 3;
    if (e <= 80)
        s = 2;
    if (e <= 50)
        s = 1;
    if (e <= 33 || !ok)
        s = 0;
    return { entropy: _entropy, strength: s, ok: s > 0, common: commonPass };
}
/*
 * Same as base64, except:
 *
 * - skips '=' at the end.
 * - uses '-' and '_' instead of '+' and '/'.
 */
function base64url_encode(data) {
    if (!data)
        return data;
    const b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=";
    let o1, o2, o3, h1, h2, h3, h4, bits, i = 0;
    const result = [];
    do {
        o1 = data[i++];
        o2 = data[i++];
        o3 = data[i++];
        bits = (o1 << 16) | (o2 << 8) | o3;
        h1 = (bits >> 18) & 0x3f;
        h2 = (bits >> 12) & 0x3f;
        h3 = (bits >> 6) & 0x3f;
        h4 = bits & 0x3f;
        result.push(b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4));
    } while (i < data.length);
    const enc = result.join("");
    const r = data.length % 3;
    return r ? enc.slice(0, r - 3) : enc;
}
/*
 * Check for non-ascii characters
 */
function isAscii(input) {
    const ascii = /^[\u0000-\u007f]*$/;
    return ascii.test(input);
}
//# sourceMappingURL=security.js.map